import { Box } from "@mui/material";

import ImageCarouselItem from "@/src/components/atoms/ImageCarouselItem";

import { cardSx } from "@/src/pages/consumer/HomePage/HomePageImageCarousel/homePageImageCarousel.styles";
import { CarData } from "@/src/pages/consumer/HomePage/homePageUtils";

interface HomePageCarouselCardProps {
  car: CarData;
}

const HomePageCarouselCard = (props: HomePageCarouselCardProps) => {
  const { car } = props;

  return (
    <Box sx={cardSx}>
      <ImageCarouselItem hasRoundBorders image={car} />
    </Box>
  );
};

export default HomePageCarouselCard;
